import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal } from 'react-bootstrap';

class FullCrawl extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);
        this.enteredHandler = this.enteredHandler.bind(this);
        this.startFullCrawl = this.startFullCrawl.bind(this);
        this.stopFullCrawl = this.stopFullCrawl.bind(this);

        this.state = {
            show: false
        };
    }
    hideHandler() {
        this.setState({ show: false });
        this.setState({ job_reference: null });
    }
    showHandler() {
        this.setState({ show: true });
    }
    enteredHandler() {
        let node = ReactDOM.findDOMNode(this.fullCrawlRef);
        if (node && node.focus instanceof Function) {
            node.focus();
        }
    }
    startFullCrawl() {
        this.props.startFullCrawl();
        this.hideHandler();
    }
    stopFullCrawl() {
        this.props.stopFullCrawl();
        this.hideHandler();
    }
    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', marginTop: '100px' }}>
                <div className="modal-container">
                    {this.props.fullCrawlActive == false &&
                        <div>
                            <Button
                                variant="success"
                                disabled={this.props.currentExtraction == null}
                                onClick={this.showHandler}
                            >
                                Start Full Crawl
                            </Button>
                        </div>
                    }
                    {this.props.fullCrawlActive == true &&
                        <div style={{ marginTop: '10px' }}>
                            {this.props.jobStats != null && this.props.jobStats.map(function (stat, i) {
                                return <div key={stat.job_reference}>{stat.job_reference}: {stat.executed_job_count}/{stat.created_job_count} (pre sample: {stat.pre_sample_job_count})</div>
                            })}
                            <Button
                                variant="danger"
                                style={{ marginTop: '90px' }}
                                onClick={this.showHandler}
                            >
                                Finish Full Crawl
                            </Button>
                        </div>
                    }
                    <Modal
                        show={this.state.show}
                        onHide={this.hideHandler}
                        onEntered={this.enteredHandler}
                        aria-labelledby="contained-modal-title"
                        onKeyPress={event => {
                            if (event.key === "Enter") {
                                this.hideHandler();
                            }
                        }}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title">
                                {!this.props.fullCrawlActive ? "Start" : "Finish"} Full Crawl For {this.props.currentExtraction?.name}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Footer>
                            <Button
                                variant={!this.props.fullCrawlActive ? "success" : "danger"}
                                onClick={!this.props.fullCrawlActive ? this.startFullCrawl : this.stopFullCrawl}
                            >
                                {!this.props.fullCrawlActive ? "Start" : "Finish"}
                            </Button>
                            <Button
                                onClick={this.hideHandler}
                                ref={input => (this.fullCrawlRef = input)}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}

export default FullCrawl;